<template>
  <div class="orgBox2">
    <div class="nav" ref="nav" v-show="navs.length">
      <span
        v-for="(nav, i) in navs"
        :key="nav.value"
        @click="changeNav(nav, i)"
        :class="{'isSearch':nav.isSearch && !i}"
      >
        <i class="el-icon-search" v-if="nav.isSearch && !i"></i><i class="el-icon-arrow-right" v-if="i"></i>{{ nav.text }}
      </span>
    </div>
    <div class="listBox" ref="listBox" :style="{ height: listHeight }">
      <orgList
        v-if="showList"
        :is-role="isRole"
        :is-search="isSearch"
        :search-keyword="realSearchKeyword"
        :pid="pid"
        ref="orgList"
      ></orgList>
    </div>
  </div>
</template>

<script>
import orgList from "./orgList.vue";
export default {
  name: "orgBox2",
  components: {
    orgList,
  },
  props: {
    searchKeyword: {
      type: String,
      default: null,
    },
    isRole: {
      type: Boolean,
      default: false,
    },
    isSearch: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      bigObjs: {},
      navs: [],
      listHeight: 0,
      showList: true,
      pid: null,
      realSearchKeyword: this.searchKeyword
    };
  },
  provide() {
    return {
      $orgBox: this,
    };
  },
  mounted() {
    this.getListHeight();
  },
  methods: {
    resize() {
      this.getListHeight();
    },
    getListHeight() {
      if (this.$refs.listBox) {
        if (this.navs.length) {
          this.listHeight = `calc(100% - ${this?.$refs?.nav?.clientHeight || 0}px)`;
        } else {
          this.listHeight = "100%";
        }
      }
    },
    toChild(item) {
      this.pid = item?.id;
      if(this.isSearch && !this.navs.length){
        if(this.realSearchKeyword){
          this.navs.push({
            text: this.realSearchKeyword,
            value: null,
            isSearch: true
          })
          this.realSearchKeyword = null;
        }else{
          this.pid = null;
          this.realSearchKeyword = item.name;
          item = null
        }
      }
      this.showList = false;
      this.$nextTick(() => {
        if (item) {
          this.navs.push({
            text: item.name,
            value: item.id,
          });
        }
        this.showList = true;
        this.$nextTick(() => {
          this.getListHeight();
        });
      });
    },
    changeNav(nav, i) {
      if (nav) {
        this.navs.splice(i);
        this.toChild({
          name: nav.text,
          id: nav.value,
        });
      } else {
        this.navs = [];
        this.toChild();
      }
    },
  },
};
</script>
